import axiosInstance from "../../../api/AxiosInstance";
import { endpoints } from "../../../services/endpoints";
import { supplierOrdersRequest, supplierOrdersRequestError, supplierOrdersRequestSuccess } from "../../slices/Dashboard/supplierOrdersSlice";

export const SuppliersOrdersAPI = () => async (dispatch) => {
    try {
        dispatch(supplierOrdersRequest());
        axiosInstance({
            method: "GET",
            url: endpoints.supplierOrdersDashboard,
            headers: { "Content-Type": "application/json" },
        })
            .then((resp) => {
                return dispatch(supplierOrdersRequestSuccess(resp?.data));
            })
            .catch((error) => {
                const _error = {
                    data: error?.response?.data?.message || error?.message,
                    status: error?.response?.status || error?.status,
                };
                return dispatch(supplierOrdersRequestError(_error));
            });
    } catch (error) { }
};
